
import {
  Component, Mixins, Prop, PropSync,
} from 'vue-property-decorator';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class MerchantRedirectNotification extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: false, default: '' }) redirectUrl!: string;

  @Prop({ required: true }) message!: string;

  @Prop({ required: true }) banner!: string;

  @Prop({ required: false, default: () => null }) beforeAuthorization!: () => Promise<void>;

  private loading = false;

  private async startAuthorization() {
    this.loading = true;
    try {
      if (this.beforeAuthorization && typeof this.beforeAuthorization === 'function') {
        await this.beforeAuthorization();
      }

      await this.$router.replace({ name: 'carrier-accounts' }).catch(() => null);
      window.location.assign(this.redirectUrl);
    } catch {
      this.loading = false;
    }
  }
}
